import type { EnabledConnectors } from '../types/chatTypes';
import euipoLogo from '../../../../../assets/icons/euipo-logo.jpg';
import eurlexLogo from '../../../../../assets/icons/eur-lex-logo.png';
import cendojLogo from '../../../../../assets/icons/boe-logo.svg';
import aepdLogo from '../../../../../assets/icons/pdf-icon.svg';
import cnmcLogo from '../../../../../assets/icons/cnmc-logo.png';

export const CHAT_CONNECTOR_DEFINITIONS: Array<{
  id: keyof EnabledConnectors;
  name: string;
  description: string;
  logoUrl: string;
}> = [
  {
    id: 'euipoCaselawsearch',
    name: 'EUIPO Case Law',
    description: 'Search EUIPO case law (trademarks, designs)',
    logoUrl: euipoLogo,
  },
  {
    id: 'euipoTmclass',
    name: 'EUIPO TMclass',
    description: 'Nice classes, HDB terms, suggestions, validation, taxonomy',
    logoUrl: euipoLogo,
  },
  {
    id: 'eurlex',
    name: 'EUR-Lex',
    description: 'Search EU legislation (regulations, directives, decisions)',
    logoUrl: eurlexLogo,
  },
  {
    id: 'cendoj',
    name: 'CENDOJ',
    description: 'Search CGPJ Spanish case law (TS, AN, TSJ, etc.)',
    logoUrl: cendojLogo,
  },
  {
    id: 'aepd',
    name: 'AEPD',
    description: 'Search AEPD resolutions and legal reports (Spanish DPA)',
    logoUrl: aepdLogo,
  },
  {
    id: 'oepm',
    name: 'OEPM',
    description: 'OEPM public CEO expediente detail and trademark search (token for Localizador)',
    logoUrl: aepdLogo,
  },
  {
    id: 'boe',
    name: 'BOE',
    description: 'BOE/BORME open-data API: daily summaries, consolidated law metadata, catalogs',
    logoUrl: cendojLogo,
  },
  {
    id: 'tc',
    name: 'Tribunal Constitucional',
    description: 'HJ jurisprudence: search portal and structured resolution JSON',
    logoUrl: aepdLogo,
  },
  {
    id: 'cnmc',
    name: 'CNMC',
    description: 'CNMC public expedientes and actuaciones/decisiones (official site lists)',
    logoUrl: cnmcLogo,
  },
];
